import { defineCatalogue } from '../../i18n';

export const adminsCatalogue = defineCatalogue(
  {
    'admins.section.title': 'Quem entra na operação',
    'admins.count.one': '{n} pessoa',
    'admins.count.other': '{n} pessoas',
    'admins.table.person': 'Pessoa',
    'admins.table.grantedAt': 'Entrou',
    'admins.table.actions': 'Ações',
    'admins.you': 'é você',
    'admins.unverified': 'E-mail não verificado',
    'admins.empty.title': 'Nenhum administrador registrado',
    'admins.empty.body': 'Adicione um administrador para conceder acesso ao painel de operações.',
    'admins.grant.open': 'Adicionar um administrador',
    'admins.grant.title': 'Adicionar um administrador da plataforma',
    'admins.grant.email.label': 'Endereço de e-mail',
    'admins.grant.email.hint':
      'Eles já devem ter feito login uma vez com este e-mail, e ele deve corresponder a exatamente uma conta.',
    'admins.grant.note.label': 'Nota (opcional)',
    'admins.grant.note.hint': 'É registrado junto com quem concedeu o acesso.',
    'admins.grant.notSignedIn':
      'Esta pessoa ainda não fez login; ela deve entrar uma vez antes de poder ser nomeada administradora.',
    'admins.grant.conflict':
      'Esta pessoa já é um administrador, ou várias contas compartilham este e-mail.',
    'admins.revoke.action': 'Revogar acesso',
    'admins.revoke.confirm.title': 'Revogar acesso de administrador?',
    'admins.revoke.confirm.body':
      'Eles perdem o acesso ao painel de operações na próxima solicitação.',
    'admins.revoke.confirm.cancel': 'Cancelar',
    'admins.revoke.confirm.confirm': 'Revogar acesso',
    'admins.lastAdmin.disabledReason':
      'A plataforma sempre mantém pelo menos um administrador; adicione outro antes de remover este.',
    'admins.lastAdmin.refused':
      'Alguém acabou de remover o outro administrador; este deve permanecer.',
    'admins.grantedAt': 'Data de concessão do acesso',
  },
  {
    'admins.section.title': 'Who enters operations',
    'admins.count.one': '{n} person',
    'admins.count.other': '{n} people',
    'admins.table.person': 'Person',
    'admins.table.grantedAt': 'Joined',
    'admins.table.actions': 'Actions',
    'admins.you': "it's you",
    'admins.unverified': 'Email not verified',
    'admins.empty.title': 'No administrators registered',
    'admins.empty.body': 'Add an administrator to grant access to the ops plane.',
    'admins.grant.open': 'Add an administrator',
    'admins.grant.title': 'Add a platform administrator',
    'admins.grant.email.label': 'Email address',
    'admins.grant.email.hint':
      'They must already have signed in once with this email, and it must match exactly one account.',
    'admins.grant.note.label': 'Note (optional)',
    'admins.grant.note.hint': 'It is recorded alongside who granted access.',
    'admins.grant.notSignedIn':
      'This person has not signed in yet; they must sign in once before they can be made an administrator.',
    'admins.grant.conflict':
      'This person is already an administrator, or several accounts share this email.',
    'admins.revoke.action': 'Revoke access',
    'admins.revoke.confirm.title': 'Revoke administrator access?',
    'admins.revoke.confirm.body': 'They lose access to the ops plane on their next request.',
    'admins.revoke.confirm.cancel': 'Cancel',
    'admins.revoke.confirm.confirm': 'Revoke access',
    'admins.lastAdmin.disabledReason':
      'The platform always keeps at least one administrator; add another before removing this one.',
    'admins.lastAdmin.refused':
      'Someone else just removed the other administrator; this one must stay.',
    'admins.grantedAt': 'Date access was granted',
  },
);

export const t = adminsCatalogue.t;
